import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService, RegistrationStepService, StepType } from '@fgb/core';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'fgbcl-registration-account-verification',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule, FGBSharedModule, PipesModule],
  templateUrl: './registration-account-verification.component.html',
  styleUrl: './registration-account-verification.component.scss',
})
export class RegistrationAccountVerificationComponent implements OnInit {
  // Input property to determine if the component is used as a form, for re-usability
  @Input() isForm: boolean = false;
  @Output() onSubmit: EventEmitter<{ valid: boolean; email: string }> = new EventEmitter();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
  readonly stepType = StepType.AccountVerify;
  private router = inject(Router);
  private authService = inject(AuthService);
  private registrationStepService = inject(RegistrationStepService);
  @Input() emailAddress: string = '';
  emailFormControl: FormControl = new FormControl('', [
    Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$'),
    Validators.required,
  ]);

  ngOnInit(): void {
    if (this.isForm) {
      this.emailFormControl.setValue(this.emailAddress);
      return;
    }
    lastValueFrom(this.registrationStepService.fetchRegistrationStepForCurrentWizard(this.stepType, true));
  }

  cancel(): void {
    if (this.isForm) {
      this.onCancel.emit();
      return;
    }
    lastValueFrom(this.authService.logout()).then(() => {
      this.router.navigate(['/login']);
    });
  }

  submitStep(): void {
    this.emailFormControl.markAllAsTouched();
    if (this.isForm) {
      this.onSubmit.emit({ valid: this.emailFormControl.valid, email: this.emailFormControl.value });
      return;
    }
    if (this.emailFormControl.valid) {
      lastValueFrom(
        this.registrationStepService.submitRegistrationStepData(this.stepType, { EmailAddress: this.emailFormControl.value })
      );
    }
  }
}
